import { Helmet } from 'react-helmet-async';

import { useTheme } from '@/hooks/theme.hooks';
import { ThemeName } from '@/types/theme';

const TITLE_BY_THEME: Record<ThemeName, string> = {
  [ThemeName.BRANDTV]: 'Sign in to BrandTV',
  [ThemeName.WEBINAR_PLUS]: 'Sign in to Webinar+',
  [ThemeName.BRANDLIVE]: 'Sign in to Brandlive',
  [ThemeName.BRANDLIVE_OLD]: 'Sign in to Brandlive',
};

export default function DocumentHead(): JSX.Element {
  const { theme } = useTheme();
  const themeName = theme?.name;
  const title = themeName ? TITLE_BY_THEME[themeName] : 'Sign in to Brandlive';

  return (
    <Helmet>
      <title>{title}</title>
      <body data-theme={themeName} />
      {/* Light favicon on dark mode, dark favicon on light mode. Fragments </> can't be used here. */}
      {themeName === ThemeName.BRANDTV && (
        <link rel="icon" href="/brandtv-light-favicon.png" media="(prefers-color-scheme: dark)" />
      )}
      {themeName === ThemeName.BRANDTV && (
        <link rel="icon" href="/brandtv-dark-favicon.png" media="(prefers-color-scheme: light)" />
      )}
      {themeName === ThemeName.WEBINAR_PLUS && (
        <link rel="icon" href="/webinar-plus-light-favicon.png" media="(prefers-color-scheme: dark)" />
      )}
      {themeName === ThemeName.WEBINAR_PLUS && (
        <link rel="icon" href="/webinar-plus-dark-favicon.png" media="(prefers-color-scheme: light)" />
      )}
      {(!themeName || themeName === ThemeName.BRANDLIVE || themeName === ThemeName.BRANDLIVE_OLD) && (
        <link rel="icon" href="/brandlive-favicon.png" />
      )}
    </Helmet>
  );
}
